import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { __, sprintf } from '@wordpress/i18n';
import { Component } from '@wordpress/element';
import { IconButton, SelectControl } from '@wordpress/components';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { noop, uniqueId } from 'lodash';
var PER_PAGE_OPTIONS = [25, 50, 75, 100];
/**
 * Use `Pagination` to allow navigation between pages that represent a collection of items.
 * The component allows for selecting a new page and items per page options.
 */

var Pagination =
/*#__PURE__*/
function (_Component) {
  _inherits(Pagination, _Component);

  function Pagination(props) {
    var _this;

    _classCallCheck(this, Pagination);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Pagination).call(this, props));
    _this.state = {
      inputValue: _this.props.page
    };
    _this.previousPage = _this.previousPage.bind(_assertThisInitialized(_this));
    _this.nextPage = _this.nextPage.bind(_assertThisInitialized(_this));
    _this.onInputChange = _this.onInputChange.bind(_assertThisInitialized(_this));
    _this.onInputBlur = _this.onInputBlur.bind(_assertThisInitialized(_this));
    _this.perPageChange = _this.perPageChange.bind(_assertThisInitialized(_this));
    _this.selectInputValue = _this.selectInputValue.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Pagination, [{
    key: "previousPage",
    value: function previousPage(event) {
      event.stopPropagation();
      var _this$props = this.props,
          page = _this$props.page,
          onPageChange = _this$props.onPageChange;

      if (page - 1 < 1) {
        return;
      }

      onPageChange(page - 1, 'previous');
    }
  }, {
    key: "nextPage",
    value: function nextPage(event) {
      event.stopPropagation();
      var _this$props2 = this.props,
          page = _this$props2.page,
          onPageChange = _this$props2.onPageChange;

      if (page + 1 > this.pageCount) {
        return;
      }

      onPageChange(page + 1, 'next');
    }
  }, {
    key: "perPageChange",
    value: function perPageChange(perPage) {
      var _this$props3 = this.props,
          onPerPageChange = _this$props3.onPerPageChange,
          onPageChange = _this$props3.onPageChange,
          total = _this$props3.total,
          page = _this$props3.page;
      onPerPageChange(parseInt(perPage));
      var newMaxPage = Math.ceil(total / parseInt(perPage));

      if (page > newMaxPage) {
        onPageChange(newMaxPage);
      }
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(event) {
      this.setState({
        inputValue: event.target.value
      });
    }
  }, {
    key: "onInputBlur",
    value: function onInputBlur(event) {
      var _this$props4 = this.props,
          onPageChange = _this$props4.onPageChange,
          page = _this$props4.page;
      var newPage = parseInt(event.target.value, 10);

      if (newPage !== page && Number.isFinite(newPage) && newPage > 0 && this.pageCount && this.pageCount >= newPage) {
        onPageChange(newPage, 'goto');
      }
    }
  }, {
    key: "selectInputValue",
    value: function selectInputValue(event) {
      event.target.select();
    }
  }, {
    key: "renderPageArrows",
    value: function renderPageArrows() {
      var page = this.props.page;

      if (this.pageCount <= 1) {
        return null;
      }

      var previousLinkClass = classNames('woocommerce-pagination__link', {
        'is-active': page > 1
      });
      var nextLinkClass = classNames('woocommerce-pagination__link', {
        'is-active': page < this.pageCount
      });
      return createElement("div", {
        className: "woocommerce-pagination__page-arrows"
      }, createElement("span", {
        className: "woocommerce-pagination__page-arrows-label",
        role: "status",
        "aria-live": "polite"
      }, sprintf(__('Page %d of %d', 'woocommerce-admin'), page, this.pageCount)), createElement("div", {
        className: "woocommerce-pagination__page-arrows-buttons"
      }, createElement(IconButton, {
        className: previousLinkClass,
        disabled: !(page > 1),
        onClick: this.previousPage,
        icon: "arrow-left-alt2",
        label: __('Previous Page', 'woocommerce-admin'),
        size: 18
      }), createElement(IconButton, {
        className: nextLinkClass,
        disabled: !(page < this.pageCount),
        onClick: this.nextPage,
        icon: "arrow-right-alt2",
        label: __('Next Page', 'woocommerce-admin'),
        size: 18
      })));
    }
  }, {
    key: "renderPagePicker",
    value: function renderPagePicker() {
      var page = this.props.page;
      var inputValue = this.state.inputValue;
      var isError = page < 1 || page > this.pageCount;
      var inputClass = classNames('woocommerce-pagination__page-picker-input', {
        'has-error': isError
      });
      var instanceId = uniqueId('woocommerce-pagination-page-picker-');
      return createElement("div", {
        className: "woocommerce-pagination__page-picker"
      }, createElement("label", {
        htmlFor: instanceId,
        className: "woocommerce-pagination__page-picker-label"
      }, __('Go to page', 'woocommerce-admin'), createElement("input", {
        id: instanceId,
        className: inputClass,
        "aria-invalid": isError,
        type: "number",
        onClick: this.selectInputValue,
        onChange: this.onInputChange,
        onBlur: this.onInputBlur,
        value: inputValue,
        min: 1,
        max: this.pageCount
      })));
    }
  }, {
    key: "renderPerPagePicker",
    value: function renderPerPagePicker() {
      // @todo Replace this with a styleized Select drop-down/control?
      var pickerOptions = PER_PAGE_OPTIONS.map(function (option) {
        return {
          value: option,
          label: option
        };
      });
      return createElement("div", {
        className: "woocommerce-pagination__per-page-picker"
      }, createElement(SelectControl, {
        label: __('Rows per page', 'woocommerce-admin'),
        value: this.props.perPage,
        onChange: this.perPageChange,
        options: pickerOptions
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          total = _this$props5.total,
          perPage = _this$props5.perPage,
          className = _this$props5.className;
      this.pageCount = Math.ceil(total / perPage);
      var classes = classNames('woocommerce-pagination', className);

      if (this.pageCount <= 1) {
        return total > PER_PAGE_OPTIONS[0] && createElement("div", {
          className: classes
        }, this.renderPerPagePicker()) || null;
      }

      return createElement("div", {
        className: classes
      }, this.renderPageArrows(), this.renderPagePicker(), this.renderPerPagePicker());
    }
  }]);

  return Pagination;
}(Component);

Pagination.propTypes = {
  /**
   * The current page of the collection.
   */
  page: PropTypes.number.isRequired,

  /**
   * A function to execute when the page is changed.
   */
  onPageChange: PropTypes.func,

  /**
   * The amount of results that are being displayed per page.
   */
  perPage: PropTypes.number.isRequired,

  /**
   * A function to execute when the per page option is changed.
   */
  onPerPageChange: PropTypes.func,

  /**
   * The total number of results.
   */
  total: PropTypes.number.isRequired,

  /**
   * Additional classNames.
   */
  className: PropTypes.string
};
Pagination.defaultProps = {
  onPageChange: noop,
  onPerPageChange: noop
};
export default Pagination;
//# sourceMappingURL=index.js.map